import { WhatsNewItem } from 'ff/debrief/models';
import { getStaticUrl } from 'ff/common/ffAppUtils';
export const WHATS_NEW_VERSIONS: { [version: number]: Date } = {
    1: new Date('2025-10-31T23:59:59Z'),
    2: new Date('2025-11-28T23:59:59Z'),
};

export const initialWhatsNewItems: WhatsNewItem[] = [
    {
        title: 'Flight Score',
        id: 'flight-score',
        description:
            'ForeFlight calculates a score for your flight. For more details, click Debrief.',
        completed: false,
        media: getStaticUrl('media/flight-score.mp4'),
        version: 1,
    },
    {
        title: 'Shared Track Logs',
        id: 'shared-tracklogs',
        description:
            'You can share track logs with other users.  If any are shared with you by another user, they will appear under the “Shared With Me” tab.',
        completed: false,
        media: getStaticUrl('media/shared-track-logs.mp4'),
        version: 1,
    },
    {
        title: 'Debrief Button',
        id: 'debrief-button',
        description:
            'Click Debrief to playback your flight and explore it in detail by reviewing segments, scoring details, data graphs, and more.',
        completed: false,
        media: getStaticUrl('media/debrief-button.mp4'),
        version: 1,
    },
    {
        title: 'Segments',
        id: 'segments',
        description:
            'ForeFlight automatically detects maneuvers, approaches, and more. Click a segment in the Debrief detail view to jump to that point in the flight.',
        completed: false,
        media: getStaticUrl('media/segments.mp4'),
        version: 1,
    },
    {
        title: 'Score Details',
        id: 'score-details',
        description:
            'These details explain what was measured about a maneuver and how the score was calculated. Review the Goal and Actual columns for specifics.',
        completed: false,
        media: getStaticUrl('media/score-details.mp4'),
        version: 1,
    },
    {
        title: 'Indicated Airspeed',
        id: 'indicated-air-speed',
        description:
            'IAS is calculated based on GPS ground speed and, if available, METAR weather data at the time.',
        completed: false,
        media: getStaticUrl('media/indicated-airspeed.mp4'),
        version: 1,
    },
    {
        title: 'Aircraft & V-Speed Configuration',
        id: 'aircraft-v-speed-configuration',
        description:
            'For the most accurate scoring, ensure the correct type of aircraft is selected. You can also override preset V-Speeds used for this aircraft.',
        completed: false,
        media: getStaticUrl('media/aircraft-v-speed-configuration.mp4'),
        version: 1,
    },
    {
        title: 'Non-Score Mode',
        id: 'non-score-mode',
        description:
            'Depending on your preference, you can choose to view debrief data with or without scores. Use this switch to toggle scoring on or off.',
        completed: false,
        media: getStaticUrl('media/non-score-mode.mp4'),
        version: 2,
    },
];
